// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__20wuj","form":"styles_form__2mK7B"};